import t from "react";
import { useTheme as d, Paper as u, Stack as E, Menu as p, MenuItem as x, ListItemIcon as b, ListItemText as f, Grid as c, Typography as s } from "@mui/material";
import C from "@mui/material/CircularProgress";
import { C as A } from "./chunk.hn4xKC_I.js";
import { jsx as h } from "react/jsx-runtime";
import { createSvgIcon as g } from "@mui/material/utils";
import { b as k } from "./chunk.DHZ1xb2E.js";
import { B as m } from "./chunk.CZnfKE1G.js";
import { I as w } from "./chunk.zlc_6vey.js";
const v = g(/* @__PURE__ */ h("path", {
  d: "M8 16h8v2H8zm0-4h8v2H8zm6-10H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm4 18H6V4h7v5h5z"
}), "DescriptionOutlined"), y = g(/* @__PURE__ */ h("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "ErrorOutlineOutlined");
function I(e) {
  const n = d();
  let a, r = k.color.transparent.black8p, i = n.palette.grey[200];
  const o = {
    width: n.spacing(3),
    height: n.spacing(3)
  };
  switch (e.status) {
    case "loading":
      a = /* @__PURE__ */ t.createElement(C, { size: 24, "aria-hidden": "true" });
      break;
    case "error":
      i = n.palette.error.main, r = n.palette.error.main, a = /* @__PURE__ */ t.createElement(
        y,
        {
          sx: {
            ...o,
            color: "white"
          },
          "aria-hidden": "true"
        }
      );
      break;
    case "success":
      i = n.palette.success.main, r = n.palette.success.main, a = /* @__PURE__ */ t.createElement(
        A,
        {
          sx: {
            ...o,
            color: n.palette.common.white
          },
          "aria-hidden": "true"
        }
      );
      break;
    default:
      a = /* @__PURE__ */ t.createElement(v, { "aria-hidden": "true", sx: o });
      break;
  }
  return /* @__PURE__ */ t.createElement(
    u,
    {
      variant: "outlined",
      sx: {
        padding: 0,
        backgroundColor: r,
        borderColor: i,
        width: n.spacing(5),
        height: n.spacing(5),
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    },
    a
  );
}
function O(e) {
  return /* @__PURE__ */ t.createElement(
    m,
    {
      "aria-label": e.ariaLabel,
      icon: e.icon,
      onClick: e.onClick
    }
  );
}
function z(e) {
  return /* @__PURE__ */ t.createElement(x, { onClick: e.onClick }, e.icon ? /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(b, null, /* @__PURE__ */ t.createElement(w, { icon: e.icon })), /* @__PURE__ */ t.createElement(f, null, e.label)) : e.label);
}
function S(e) {
  const [n, a] = t.useState(null), r = !!n, i = (l) => {
    a(l.currentTarget);
  }, o = () => {
    a(null);
  };
  return /* @__PURE__ */ t.createElement(E, { direction: "row", spacing: 1 }, e.primaryAction && /* @__PURE__ */ t.createElement(O, { ...e.primaryAction }), e.additionalActions && (Array.isArray(e.additionalActions) ? /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
    m,
    {
      id: "more-button",
      "aria-label": "More",
      icon: "more_horiz",
      onClick: i
    }
  ), /* @__PURE__ */ t.createElement(
    p,
    {
      id: "actions-menu",
      anchorEl: n,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right"
      },
      open: r,
      onClose: o,
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      slotProps: {
        paper: {
          sx: {
            minWidth: "256px"
          }
        }
      },
      MenuListProps: {
        "aria-labelledby": "more-button"
      }
    },
    e.additionalActions.map((l) => /* @__PURE__ */ t.createElement(z, { key: l.label, ...l }))
  )) : /* @__PURE__ */ t.createElement(
    m,
    {
      "aria-label": e.additionalActions.ariaLabel,
      icon: e.additionalActions.icon,
      onClick: e.additionalActions.onClick
    }
  )));
}
function j(e) {
  const n = d(), a = {
    padding: 2,
    borderRadius: "8px",
    minWidth: "224px"
  }, r = {
    color: n.palette.typography.lowEmphasis,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  };
  return e.status === "error" && (a.backgroundColor = n.palette.error.light, a.borderColor = n.palette.error.main, a.borderWidth = "2px", r.color = n.palette.error.dark), e.status === "loading" && (r.fontStyle = "italic"), /* @__PURE__ */ t.createElement(u, { variant: "outlined", sx: a }, /* @__PURE__ */ t.createElement(
    c,
    {
      container: !0,
      spacing: 2,
      sx: {
        margin: 0,
        width: "100%",
        flexWrap: "nowrap",
        alignItems: "center"
      }
    },
    /* @__PURE__ */ t.createElement(c, { sx: { alignItems: "center", pl: 0 } }, /* @__PURE__ */ t.createElement(I, { status: e.status })),
    /* @__PURE__ */ t.createElement(
      c,
      {
        sx: {
          flexGrow: "1",
          pl: 2,
          overflow: "hidden"
        }
      },
      /* @__PURE__ */ t.createElement(
        s,
        {
          variant: "h4",
          sx: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          },
          title: e.labelText
        },
        e.labelText
      ),
      e.descriptionText && /* @__PURE__ */ t.createElement(s, { variant: "body2", sx: r }, e.descriptionText)
    ),
    /* @__PURE__ */ t.createElement(
      c,
      {
        sx: {
          pl: 2
        }
      },
      (e.primaryAction || e.additionalActions) && /* @__PURE__ */ t.createElement(
        S,
        {
          primaryAction: e.primaryAction,
          additionalActions: e.additionalActions
        }
      )
    )
  ));
}
export {
  j as D
};
